import { Form, Formik } from 'formik';

import { useInputFocusRef } from 'components/intakeForm/FormHelpers';
import { HealthPlanAndPatientInputs } from 'components/intakeForm/HealthPlanAndPatientInputs';
import { type IntakeFormSectionProps } from 'components/intakeForm/IntakeFormSectionProps';
import { useAppDispatch, useAppSelector } from 'store';
import { FormSections, IntakeFormSectionSchemas } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';
import { goToNextSection } from 'store/intakeForm/intakeFormThunks';

const Section = FormSections.HEALTH_PLAN_AND_PATIENT;

export const HealthPlanAndPatient = ({ isOpen }: IntakeFormSectionProps) => {
    const dispatch = useAppDispatch();
    const { activeSection, capturedData } = useAppSelector((state) => state.intakeForm);

    const healthPlanRef = useInputFocusRef(isOpen, activeSection, Section);

    return (
        <Formik
            initialValues={capturedData[Section]}
            enableReinitialize
            validateOnMount
            validationSchema={IntakeFormSectionSchemas[Section]}
            onSubmit={(values) => {
                dispatch(updateCapturedData({ [Section]: values }));
                dispatch(goToNextSection(Section));
            }}
        >
            {(formik) => (
                <Form className="sds_intake-form-section">
                    <HealthPlanAndPatientInputs
                        onConfirmPatient={formik.handleSubmit}
                        healthPlanRef={healthPlanRef}
                    />
                </Form>
            )}
        </Formik>
    );
};
